var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 169,
    viewBox: "0 0 1024 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H1000C1013.25 0 1024 10.7452 1024 24V169H0V24Z",
    fill: "#3B1687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundHeader);
export default __webpack_public_path__ + "static/media/background_header.6684d022b04c6e2f2abd0c7b5387e496.svg";
export { ForwardRef as ReactComponent };